import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import patientAvatar from "../icons/avatar.png";
import "./index.css";
// import UserContext from "../../../context/userContext";
import StarRatings from "react-star-ratings";
import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";
// @ts-ignore
import { pdfjs } from "react-pdf";

// @ts-ignore
import { authHeader } from "auth/authHeader";
import axios from "axios";
import moment from "moment";
import { LinearProgress } from "@mui/material";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const AppointmentDetailsPage = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    // let userValue = useContext(UserContext);
    let { user_id, user_type } = { user_id: 11, user_type: 2 };
    const [orderStatus, setOrderStatus] = useState(2);
    const [data, setData] = useState(null);
    const [timeFilter, setTimeFilter] = useState("ALL");
    const [reviewData, setReviewData] = useState(null);

    const [pdfUrl, setPdfUrl] = useState('');

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const pp = "sample.pdf";

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const loadDetails = () => {
        // setLoading(true);
        axios
            .get(`${process.env.REACT_APP_BACKEND_URL}appointment/${params.id}`, {
                headers: authHeader(),
            })
            .then(function (response) {
                setData(response.data.data?.[0]);
            })
            .catch((error) => {
                // JSON.stringify(error);
                console.log(error);
                // setError("Invalid Credentials");
            })
            .finally(() => {
                // setLoading(false);
            });
    };

    const loadComments = () => {
        // setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_BACKEND_URL}appointment-review/${params.id}`,
                {
                    headers: authHeader(),
                }
            )
            .then(function (response) {
                setReviewData(response.data.data);
            })
            .catch((error) => {
                // JSON.stringify(error);
                console.log(error);
                // setError("Invalid Credentials");
            })
            .finally(() => {
                // setLoading(false);
            });
    };
    useEffect(() => {
        setPdfUrl(data?.prescriptionBase64PdfString);
    }, [data]);

    useEffect(() => {
        loadDetails();
        loadComments();
    }, []);

    const getAttachmentNameFromUrl = (url) => {
        let last = url.substring(url.lastIndexOf("/") + 1, url.length);
        let splitted = last.split("?AWSAccessKeyId=");
        return splitted[0];
    };

    const getAttachmentNameFromTitle = (title) => {
        let arr = title.split(' ');
        if (arr.length > 2)
            return `${arr[0]} ${arr[1]}`
        else
            return arr[0]
    };

    const styles = {
        dialog: {
            backgroundImage:
                "url(https://cdn.pixabay.com/photo/2017/03/14/03/20/woman-2141808_960_720.jpg)",
        },
    };

    const appointmentTime = moment(
        `${data?.date} ${data?.slotTime}`,
        "YYYY-MM-DD HH:mm"
    );

    if (!data) return <LinearProgress />;

    return (
        <div className="appointmentDetailMain" style={{ paddingTop: 25 }}>
            <div className="appointmentDetailHeading">
                <div onClick={() => navigate(-1)}>
                    <ArrowCircleLeftOutlinedIcon
                        className="headingIcon"
                        fontSize="large"
                    />
                </div>

                <h3>Appointment Details</h3>
            </div>
            <Grid container>
                <Grid item xs={12} md={6} lg={7}>
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            "& > :not(style)": {
                                ml: 2,
                                mr: 1,
                                mb: 1,
                                pl: 3,
                                pb: 4,
                                pr: 3,
                                width: "100%",
                                height: "auto",
                            },
                        }}
                    >
                        <Paper elevation={1}>
                            <Stack direction="row" spacing={2}>
                                <Avatar
                                    alt="Patient Avatar"
                                    src={data?.Doctor?.User?.profileImagePath || patientAvatar}
                                    className="appointmentDetailAvatar"
                                />
                                <div className="patientAppointmentDetail">
                                    <h4>{data?.purpose}</h4>
                                    <h5>{data?.Doctor?.name}</h5>
                                    <p>
                                        {/* Specialist{" "} */}
                                        {data?.Doctor.serviceCategories.map((e) => {
                                            return `${e}  `;
                                        })}
                                    </p>
                                </div>
                            </Stack>
                            <div className="appointmentDetailsTime">
                                <h4>{appointmentTime.fromNow()}</h4>
                                <p>{`${data?.appointmentType} | ${data?.purpose}`}</p>
                            </div>
                            <div className="appointmentDetailContent" >
                                <p>Name</p>
                                <h4>{data?.Patient.name}</h4>
                                <Grid container>
                                    <Grid xs={6} md={6} lg={3}>
                                        <p>Medical Details 1</p>
                                        <h4>{data?.medicalDetails}</h4>

                                        <p>Attachment</p>


                                                <div className="attachment-main" style={{ display: "block", marginLeft:"5px"}}>
                                                    {(data?.attachments.length > 0) || (data?.AppointmentComments.length > 0) ? (
                                                        <>
                                                            {data.attachments.map((e, i) => {
                                                                return (
                                                                    <a className="attachment-file" key={'att' + i} style={{ marginBottom: "5px", }} href={e}>
                                                                        <FilePresentOutlinedIcon fontSize="small" />
                                                                        <div style={{ overflow: "hidden" }}>
                                                                            <p>{getAttachmentNameFromUrl(e)}</p>
                                                                        </div>
                                                                    </a>
                                                                );
                                                            })}
                                                            {data.attachmentPdfString.map((attachment) => {
                                                                return (
                                                                    <a className="attachment-file" key={attachment.filename}
                                                                        style={{ marginBottom: "5px" }}
                                                                        href={attachment.url}>
                                                                        <FilePresentOutlinedIcon fontSize="small" />
                                                                        <p>{getAttachmentNameFromTitle(attachment.title)}</p>
                                                                    </a>
                                                                );
                                                            })}
                                                        </>

                                                    ) : (
                                                        <p>No Attachments </p>
                                                    )}
                                                </div>

                                    </Grid>
                                    {/* <Grid xs={6} md={6} lg={3}>
                    <p>Medical Details 1</p>
                    <h4>Type</h4>
                    <p>Medical Details 2</p>
                    <h4>Type</h4>
                    <p>Medical Details 1</p>
                    <h4>Type</h4>
                    <p>Medical Details 2</p>
                    <h4>Type</h4>
                  </Grid> */}
                                </Grid>
                            </div>

                            <h4>Reviews</h4>
                            <div className="reviewsDetail">
                                <Grid container>
                                    {reviewData?.patient && (
                                        <Grid xs={12} md={12} lg={6}>
                                            <Paper elevation={1} className="PatientReviewsAvatar">
                                                <Stack direction="row" spacing={2}>
                                                    <div className="PatinetReviewUserName">
                                                        <p>{reviewData?.patient?.FromUser?.username}</p>
                                                        <div className="PatientStarRating">
                                                            <StarRatings
                                                                rating={reviewData?.patient?.rate}
                                                                starDimension="12px"
                                                                starRatedColor="orange"
                                                                numberOfStars={5}
                                                                starSpacing="1px"
                                                            />
                                                        </div>
                                                    </div>
                                                </Stack>
                                                <p>{reviewData?.patient?.comment}</p>
                                            </Paper>
                                        </Grid>
                                    )}
                                    {reviewData?.doctor && (
                                        <Grid xs={12} md={12} lg={6}>
                                            <Paper elevation={1} className="PatientReviewsAvatar">
                                                <Stack direction="row" spacing={2}>
                                                    <div className="PatinetReviewUserName">
                                                        <p>{reviewData?.doctor?.FromUser?.username}</p>
                                                        <div className="PatientStarRating">
                                                            <StarRatings
                                                                rating={reviewData?.doctor?.rate}
                                                                starDimension="12px"
                                                                starRatedColor="orange"
                                                                numberOfStars={5}
                                                                starSpacing="1px"
                                                            />
                                                        </div>
                                                    </div>
                                                </Stack>
                                                <p>{reviewData?.doctor?.comment}</p>
                                            </Paper>
                                        </Grid>
                                    )}
                                </Grid>
                            </div>
                        </Paper>
                    </Box>
                </Grid>
                <Grid xs={12} md={6} lg={5}>
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            "& > :not(style)": {
                                mr: 1,
                                ml: 2,
                                pl: 3,
                                pb: 3,
                                pr: 4,
                                width: "100%",
                                height: "auto",
                            },
                        }}
                    >
                        <Paper
                            elevation={1}
                            className="paper-prescription"
                            style={{ height: "auto" }}
                        >
                            <h3>Prescription</h3>
                            <div>
                                <object data={pdfUrl} type="application/pdf" style={{ height: "60vh", width: "45vh" }} />

                            </div>
                            <>
                                <h3>Comments</h3>
                                AppointmentComments
                                {data?.AppointmentComments?.map((comment) => {
                                    return (
                                        <div>
                                            <div
                                                key={comment.id}
                                                style={{ marginTop: 8 }}
                                                className="priscriptionComments"
                                            >
                                                <span style={{ padding: 4 }}>{comment.comment} </span>
                                            </div>
                                        </div>


                                    );
                                })}

                                {data?.AppointmentComments?.length > 0 ? ('') : (<p>No Comments </p>)}

                            </>
                        </Paper>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
};
export { AppointmentDetailsPage };
